import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody48';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy48 = ({setBlank}) => {
     
 
    const headings = "<h2 style='display:inline-block;color:#ffffff;transform:scale(0.85);transform-origin:left;'>Due Diligence & Commercial Evaluation:</h2><h4> Proposed Sustainable Materials Joint Venture</h4>";
  return (
    <>
        <Helmet>
        <title>Due Diligence & Commercial Evaluation</title>
        <meta property="og:title" content="Due Diligence & Commercial Evaluation: Proposed Sustainable Materials Joint Venture" />
        <meta property='og:description' content='Due Diligence & Commercial Evaluation: Proposed Sustainable Materials Joint Venture'/> 
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy48" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy48
